// Desktop browser detection - check most specific browsers first
export const isBrave = !!navigator.brave || (navigator.userAgentData?.brands?.some(brand => brand.brand === "Brave")) || false;
export const isVivaldi = navigator.userAgent.indexOf("Vivaldi") != -1;
export const isSamsungInternet = navigator.userAgent.indexOf("SamsungBrowser") != -1;
export const isEdge = navigator.userAgent.indexOf("Edg") != -1;
export const isOpera = navigator.userAgent.indexOf("Opera") != -1 || navigator.userAgent.indexOf("OPR") != -1;
export const isFirefox = navigator.userAgent.indexOf("Firefox") != -1;
export const isChrome = !isEdge && !isOpera && !isVivaldi && !isSamsungInternet && !isBrave && navigator.userAgent.indexOf("Chrome") != -1;
export const isSafari = !isChrome && !isEdge && !isOpera && !isVivaldi && !isSamsungInternet && !isBrave && navigator.userAgent.indexOf("Safari") != -1;

export function getBrowserInfo() {
    let family = "Unknown";
    let name = "Unknown";
    let version = null;

    // Check browsers in order of specificity (most specific first)
    if (isBrave) {
        family = "Brave";
        version = getChromeVersion(); // Brave uses Chromium
        name = version ? `Brave ${version}` : "Brave";
    } else if (isVivaldi) {
        family = "Vivaldi";
        version = getVivaldiVersion();
        name = version ? `Vivaldi ${version}` : "Vivaldi";
    } else if (isSamsungInternet) {
        family = "Samsung Internet";
        version = getSamsungInternetVersion();
        name = version ? `Samsung Internet ${version}` : "Samsung Internet";
    } else if (isEdge) {
        family = "Edge";
        version = getEdgeVersion();
        name = version ? `Edge ${version}` : "Edge";
    } else if (isOpera) {
        family = "Opera";
        version = getOperaVersion();
        name = version ? `Opera ${version}` : "Opera";
    } else if (isChrome) {
        family = "Chrome";
        version = getChromeVersion();
        name = version ? `Chrome ${version}` : "Chrome";
    } else if (isSafari) {
        family = "Safari";
        version = getSafariVersion();
        name = version ? `Safari ${version}` : "Safari";
    } else if (isFirefox) {
        family = "Firefox";
        version = getFirefoxVersion();
        name = version ? `Firefox ${version}` : "Firefox";
    }

    return { family, name, version };
}

export function getChromeVersion() {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return raw ? parseInt(raw[2], 10) : false;
}

export function getSafariVersion() {
    if (isSafari) {
        var raw = navigator.userAgent.match(/Version\/([0-9]+)\./);
        return raw ? parseInt(raw[1], 10) : false;
    } else {
        return false;
    }
}

export function getFirefoxVersion() {
    if (isFirefox) {
        var raw = navigator.userAgent.match(/Firefox\/([0-9]+)/);
        return raw ? parseInt(raw[1], 10) : false;
    }
    return false;
}

export function getEdgeVersion() {
    if (isEdge) {
        var raw = navigator.userAgent.match(/Edg\/([0-9]+)/);
        return raw ? parseInt(raw[1], 10) : false;
    } else {
        return false;
    }
}

export function getOperaVersion() {
    if (isOpera) {
        var raw = navigator.userAgent.match(/(?:Opera|OPR)\/([0-9]+)/);
        return raw ? parseInt(raw[1], 10) : false;
    } else {
        return false;
    }
}

export function getSamsungInternetVersion() {
    if (isSamsungInternet) {
        var raw = navigator.userAgent.match(/SamsungBrowser\/([0-9]+)\./);
        return raw ? parseInt(raw[1], 10) : false;
    } else {
        return false;
    }
}

export function getVivaldiVersion() {
    if (isVivaldi) {
        var raw = navigator.userAgent.match(/Vivaldi\/([0-9]+)\./);
        return raw ? parseInt(raw[1], 10) : false;
    } else {
        return false;
    }
}

function createRange(node, count, range) {
    if (!range) {
        range = document.createRange();
        range.selectNode(node);
        range.setStart(node, 0);
    }

    if (count === 0) {
        range.setEnd(node, count);
    } else if (node && count > 0) {
        if (node.nodeType === Node.TEXT_NODE) {
            if (node.textContent.length < count) {
                count -= node.textContent.length;
            } else {
                range.setEnd(node, count);
                count = 0;
            }
        } else {
            for (let i = 0; i < node.childNodes.length; i++) {
                range = createRange(node.childNodes[i], count, range);

                if (count === 0) {
                    break;
                }
            }
        }
    }

    return range;
}

export function setCaretPosition(node = document.activeElement, index = 0) {
    if (index <= 0) {
        return;
    }

    const selection = window.getSelection();
    const range = createRange(node.parentNode, index);
    if (range) {
        range.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range);
    }
}

export function getCaretPosition(node = document.activeElement) {
    let position = 0;
    let selection;
    let range;

    if (window.getSelection) {
        selection = window.getSelection();
        if (selection.rangeCount) {
            range = selection.getRangeAt(0);
            if (range.commonAncestorContainer.parentNode == node) {
                position = range.endOffset;
            }
        }
    } else if (document.selection && document.selection.createRange) {
        range = document.selection.createRange();

        if (range.parentElement() === node) {
            const el = document.createElement("span");
            node.insertBefore(el, node.firstChild);

            const temp = range.duplicate();
            temp.moveToElementText(el);
            temp.setEndPoint("EndToEnd", range);
            position = temp.text.length;
        }
    }

    return position;
}
